import { createSlice } from '@reduxjs/toolkit';
import { RolesApprovedStateType } from 'src/types/rolesApproved';

const initialState: RolesApprovedStateType = {
    data: null,
    loading: false,
    error: false,
};
export const rolesApprovedSlice = createSlice({
    name: 'rolesApproved',
    initialState,
    reducers: {
        getRolesApprovedFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getRolesApprovedFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getRolesApprovedFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getRolesApprovedFetch,
    getRolesApprovedFetchSuccess,
    getRolesApprovedFetchFailure,
} = rolesApprovedSlice.actions;

export default rolesApprovedSlice.reducer;
